var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$t(`btn-toggle ${this.isActive ? 'active' : ''}`)},[_c('div',{staticClass:"toggle__text"},[_vm._v("Country Mode")]),_c('div',{staticClass:"toggle__circle",on:{"click":_vm.toggleActive}}),_c('div',{staticClass:"toggle__text toggle__text__last"},[_vm._v("City Mode")])])
}
var staticRenderFns = []

export { render, staticRenderFns }